export function buildHappDeepLink(subscriptionUrl) {
    return `happ://add/${subscriptionUrl}`;
}

export function openInHapp(subscriptionUrl) {
    window.location.href = buildHappDeepLink(subscriptionUrl);
}
